import React from "react";
import { dto_common } from "../../../../classes/dto-common";
import "../../../../styles/css/pg-cart.css";

function Schedule({ SheduleDesc, onClick }) {
  return (
    <div className="pgCartAdd" style={{ paddingLeft: "8px" }}>
      <div className="pgCartAddWrap">
        <i
          className="bi bi-clock-fill"
          aria-hidden="true"
          style={{ fontSize: "24px" }}
        ></i>
        <div>
          <p>{"Time  : " + dto_common.SCHEDULEDTIME}</p>
          <p>{"Date    : " + dto_common.SCHEDULEDDATE}</p>
        </div>
      </div>

      <div
        style={{ width: "40px" }}
        onClick={() => {
          onClick();
        }}
      >
        <i
          className="bi bi-caret-right-fill"
          aria-hidden="true"
          style={{ fontSize: "18px" }}
        ></i>
      </div>
    </div>
  );
}

export default Schedule;
